import React from "react";
import { useQuery } from "../../_utils/url_query_hook";
import { buildEmptyCompetency, transformEntityCompetency } from "../../_events/competency/model";
import { findCompetencyByIdEvent } from "../../_events/competency/find.event";
import { createCompetencyEvent, editCompetencyEvent } from "../../_events/competency/create.event";
import { alertError, alertSuccess } from "../../_utils/alerts";

export const useCompetencyCreateEdit = () => {

    const query = useQuery();
    const uuid = query.get("id");

    const [ entity, setEntity ] = React.useState(buildEmptyCompetency());

    const create = () => {
        createCompetencyEvent(entity)
        .then(json => {
            alertSuccess("Guardado");
            setEntity(buildEmptyCompetency());
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    const edit = () => {
        editCompetencyEvent(uuid, entity)
        .then(json => {
            alertSuccess("Actualizado");
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        if(uuid){
            findCompetencyByIdEvent(uuid)
            .then(json => {
                setEntity(transformEntityCompetency(json.data));
            })
            .catch(err => {
                alertError(err.message);
            })
        }
    }, [uuid]);

    return { entity, setEntity, uuid, create, edit };
}